import { createFileRoute } from '@tanstack/react-router'
import { StatementPage } from '../../../../features/commissions/statement-page'

export const Route = createFileRoute('/_app/commissions/statements/$statementId')({
  staticData: { crumb: 'commissionStatement' },
  component: StatementPage,
})
